"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var collection_1 = require("../util/collection");
var Hooks = (function () {
    function Hooks() {
        this.map = {};
        this.map = {};
    }
    ;
    Hooks.prototype.set = function (hook, handler) {
        if (!this.map.hasOwnProperty(hook)) {
            this.map[hook] = [];
        }
        var value = { handler: handler, remove: function () { } };
        var remove = collection_1.addAndRemoveFromCollection(this.map[hook], value);
        value = { handler: handler, remove: remove };
        return remove;
    };
    ;
    Hooks.prototype.get = function (hook) {
        var value = this.map[hook];
        return value ? value.map(function (val) { return val.handler; }) : undefined;
    };
    ;
    Hooks.prototype.run = function (hook, final, context) {
        var initialArgs = [];
        for (var _a = 3; _a < arguments.length; _a++) {
            initialArgs[_a - 3] = arguments[_a];
        }
        var initialArgs = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            initialArgs[_i - 3] = arguments[_i];
        }
        var index = 0;
        var handlers = this.get(hook) || [];
        function handler() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var childHandler = handlers[index++];
            if (childHandler) {
                return childHandler(handler).apply(context, args);
            }
            return final.apply(context, args);
        }
        return handler.apply(context, initialArgs);
    };
    ;
    return Hooks;
}());
exports.default = Hooks;
